import React, { useEffect, useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';
import { VariableStatements } from './VariableStatements';
import { getPageListStatement, postStatement } from '../../../store/Actions/ActionStatements';
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom';

function AddStatement({ open, setOpen }) {
    let { mode, dispatch,langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    const { state, setStateCustom,setState,setLoad } = VariableStatements()
    const { page_list_statement, loadingPageListStatement } = useSelectorCustom()
    const [production_crew , setproduction_crew] = useState([])
    const Submit = e => {
        e.preventDefault()
        dispatch(postStatement(state, setLoad))
    }
    useEffect(()=>{
        dispatch(getPageListStatement())
    },[])
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            number: page_list_statement?.expense_number,
        }));
    }, [page_list_statement])
    useEffect(() => {
        if(state?.project_id !== ''){
            page_list_statement?.projects?.map((project)=>{
                if(project?.id === parseInt(state?.project_id)){
                    setproduction_crew(project?.production_crews)
                }
            })
        }
    }, [state?.project_id])
    const formFields = [
        { name: 'number', label: 'statement_number', type: 'text', inputType: 'text', iconType: "pencil", disabled: true },
        { name: 'statement_date', label: 'statement_date', type: 'date', inputType: 'text', iconType: "calendar" },
        {
            name: "type", label: "type", type: "text", inputType: 'one_select', iconType: "pencil",
            options: page_list_statement?.expense_statement_types,
        },
        {
            name: "account_id", label: "account", type: "text", inputType: 'one_select', iconType: "user",
            options: page_list_statement?.accounts?.map((account)=>({
                value: account?.id,
                label: account?.name
            })),
        },
        {
            name: "project_id", label: "project", type: "text", inputType: 'one_select', iconType: "user",
            options: page_list_statement?.projects?.map((project)=>({
                value: project?.id,
                label: project?.name
            })),
        },
        {
            name: "production_crew", label: "production_crew", type: "text", inputType: 'multi_select', iconType: "user",
            options: production_crew?.map((project)=>({
                value: project?.id,
                label: project?.name
            })),
        },
    ];
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div className={`div_title_popup ${mode === 'dark' ? "darktoppopup" : "lighttoppopup"}`} >
                    <p className={`title_popup ${mode === 'dark' ? "darktext" : "lighttext"}`}  >{translate('add_statement')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={Submit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
            </div>
        </RModal>
    )
}

export default AddStatement


